module.exports = __webpack_public_path__ + "img/永为客模具.1bcacf52.png";